import React from 'react';
import { Link } from 'react-router-dom';

import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';

import styles from './EndPages.module.scss';

const PAGE_TITLE = 'Thank you for your interest.';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    Unfortunately, your application was declined due to a verification error. You may qualify for a
    loan by restarting the application process.
    <br />
    <br />
    Please create a new application to get started.
  </p>
);

const VerificationErrorPage = () => {
  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />
      <Link to={CuroAppRoute.ApplyProcess}>
        <Button kind="primary" size="form">
          Apply Now
        </Button>
      </Link>
    </>
  );
};

export default VerificationErrorPage;
